// Central content for Karting Bahamas. Edit these values to update the site.

export const LOGOS = {
  full: "/logos/kb-full.png",
  icon: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c91006d6-c19f-4fea-9c4f-bfae664dc811/artifacts/spbk4rqo_KB%20Icon%20.png",
  edukarting: "/logos/edukarting.jpg",
  bac: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c91006d6-c19f-4fea-9c4f-bfae664dc811/artifacts/p2xggwkb_BAC%20Logo.png",
};

// Real photography of the Karting Bahamas track at the Thomas A. Robinson Stadium parking lot.
const REAL = {
  raceAction: "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-karting/artifacts/2q2cez3b_30d5e4a5-ee50-47af-9060-369c553bb5ce.webp", // kart #14 mid-corner (landscape)
  duskRace: "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-karting/artifacts/738iyf47_6b6b99e1-f3c6-424f-879e-365e161477ee.webp",   // 3 red karts at dusk
  corner: "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-karting/artifacts/g9h94cmf_IMG_2678.webp",                                 // empty tyre-lined corner
  juniorTrack: "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-karting/artifacts/tsvav6sq_IMG_2865.webp",                            // junior track, two karts
  paddock: "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-karting/artifacts/xmt7sn21_IMG_2870.webp",                                // paddock kart lineup
};

// Keys kept stable so existing pages resolve; all now point to REAL venue photography.
export const IMAGES = {
  heroMotion: REAL.raceAction,
  trackDrone: REAL.corner,
  trackDrone2: REAL.paddock,
  eduKids: REAL.juniorTrack,
  corporate: REAL.paddock,
  racingAction: REAL.duskRace,
  motionBlur2: REAL.duskRace,
  juniorTrack: REAL.juniorTrack,
};

export const TRACKS = [
  {
    name: "The Main Circuit",
    tag: "Adults & Experienced Drivers",
    image: REAL.raceAction,
    desc: "Track 1 is our larger circuit — 9 turns and a full main straight to open up the throttle, all defined and protected by recycled tyre walls. Real, competitive wheel-to-wheel racing.",
    specs: ["9 turns + 1 main straight", "Adult karts", "Recycled tyre barriers", "Marshaled race sessions"],
  },
  {
    name: "The Junior Track",
    tag: "Kids & First-Timers",
    image: REAL.juniorTrack,
    desc: "Track 2 is built for the kids — a mini-kart circuit with 4 turns and a main straight, laid out in the shape of a giant capital 'B'. Fun, safe and right beside the main track.",
    specs: ["4 turns + 1 main straight", "Shaped like a giant 'B'", "Mini karts for kids", "Parent viewing area"],
  },
];

export const GALLERY = [
  { src: REAL.raceAction, label: "Wheel To Wheel", span: "wide" },
  { src: "/edukart/ek-c.jpg", label: "EduKarting Action", span: "tall" },
  { src: REAL.duskRace, label: "Dusk Battle", span: "normal" },
  { src: REAL.corner, label: "Tyre-Lined Corner", span: "normal" },
  { src: REAL.paddock, label: "The Paddock", span: "tall" },
  { src: "/edukart/ek-b.jpg", label: "Speed Week Heritage", span: "wide" },
  { src: REAL.juniorTrack, label: "Junior Track", span: "normal" },
];

export const CONTACT = {
  address: "Bahamas Games Blvd, Southern Parking Lot, Thomas A. Robinson National Stadium, Nassau, The Bahamas",
  phone: "+1 (242) 535-9171",
  email: "edukartingbahamas26@gmail.com",
  eventsEmail: "edukartingbahamas26@gmail.com",
  hours: [
    { day: "Saturday", time: "10:00 AM – 8:30 PM" },
    { day: "Sunday", time: "10:00 AM – 8:30 PM" },
    { day: "Monday – Friday", time: "Closed" },
  ],
  mapEmbed: "https://www.google.com/maps?q=Thomas%20A.%20Robinson%20National%20Stadium%2C%20Bahamas%20Games%20Blvd%2C%20Nassau&output=embed",
  socials: [
    { name: "EduKarting Bahamas", href: "https://www.instagram.com/edukarting.bahamas/", icon: "instagram" },
    { name: "Road Safety Bahamas", href: "https://www.instagram.com/road.safety.bahamas/", icon: "instagram" },
    { name: "Antique Auto Club Bahamas", href: "https://www.instagram.com/antiqueautoclubbahamas/", icon: "instagram" },
  ],
};

export const STATS = [
  { value: "150", suffix: "K+", label: "Sq Ft Of Track" },
  { value: "2", suffix: "", label: "Tracks" },
  { value: "2000", suffix: "+", label: "Recycled Tyres" },
  { value: "6", suffix: "+", label: "Karts Racing" },
];

export const PRICING = [
  {
    name: "Single Race",
    price: "$30",
    responder: "$24",
    unit: "/ race",
    tag: "Most Popular",
    description: "One 10-minute race on the main or junior track. Same suggested donation for adults and juniors.",
    features: ["10 minutes of racing", "Adult or junior track", "Helmet & safety briefing", "No booking required", "Cashless — card donations on track"],
    highlight: true,
  },
  {
    name: "3 Races",
    price: "$75",
    responder: "$60",
    unit: "/ driver",
    tag: "Save $15",
    description: "Three 10-minute races back-to-back — great value for a proper track session.",
    features: ["Three 10-minute races", "Adult or junior track", "Beat your personal best", "No booking required", "Cashless — card donations on track"],
    highlight: false,
  },
  {
    name: "5 Races",
    price: "$100",
    responder: "$80",
    unit: "/ driver",
    tag: "Best Value",
    description: "Five 10-minute races — our best per-race value for the true racer.",
    features: ["Five 10-minute races", "Adult or junior track", "Our best per-race value", "No booking required", "Cashless — card donations on track"],
    highlight: false,
  },
];

// 20% first-responder discount, shown alongside standard pricing.
export const RESPONDER_PRICING = [
  { name: "Single Race", price: "$24" },
  { name: "3 Races", price: "$60" },
  { name: "5 Races", price: "$80" },
];

export const PACKAGES = [
  {
    name: "Corporate Grand Prix",
    ideal: "Team building • Client events",
    desc: "A fully hosted event on the main circuit with team qualifying, a group race and a podium ceremony.",
    points: ["Up to 40 drivers", "Reserved track time", "Refreshment options", "Podium & bragging rights"],
    image: REAL.paddock,
  },
  {
    name: "Birthday Race Party",
    ideal: "Kids & adults",
    desc: "Reserved time, races for your whole crew, and a podium finish — main track or junior track.",
    points: ["Reserved group session", "Multiple races per guest", "Dedicated host", "Main or junior track"],
    image: REAL.duskRace,
  },
  {
    name: "Group / Squad Bash",
    ideal: "Stags • Squads • Reunions",
    desc: "Bring the crew for a high-octane grid battle and settle who's really the fastest.",
    points: ["8–24 drivers", "Group qualifying", "Reserved seating", "Photo opportunities"],
    image: REAL.raceAction,
  },
];

export const MANIFESTO = [
  { no: "01", title: "Born From The Speed Week Revivals", body: "The programme behind Karting Bahamas was born over a decade ago out of the world-famous Nassau Speed Week Revivals (2011–2013), organised by David McLaughlin and Susan Schauff — reigniting Bahamian motorsport." },
  { no: "02", title: "Built From Recycled Tyres", body: "Every corner is shaped and protected by 2,000+ recycled used car tyres. It's a grassroots, resourceful and genuinely Bahamian take on a racing circuit." },
  { no: "03", title: "Two Tracks, All Ages", body: "A larger main circuit for adults and experienced drivers, plus a dedicated junior track so kids can race safely on a course built just for them." },
  { no: "04", title: "A Vision For The Future", body: "This is only the beginning. Every lap you run helps build the case for a permanent, state-of-the-art karting complex — capable of hosting national and international FIA Karting Championships right here in The Bahamas." },
];

export const FAQS = [
  { q: "Where is Karting Bahamas?", a: "We're set up on the 150,000+ sq ft Southern Parking Lot of the Thomas A. Robinson National Stadium in Nassau. The circuit is built directly on the lot and lined with recycled used car tyres." },
  { q: "Is this a permanent karting facility?", a: "Not yet! Right now Karting Bahamas is a real, hand-built track on a large stadium parking lot. Our goal is to prove the demand for karting in The Bahamas and eventually build a permanent, state-of-the-art karting complex." },
  { q: "Do I need to book?", a: "No. Karting Bahamas is arrive-and-drive. Individuals and groups of friends simply walk in, sign the liability waiver, donate on track and race. Booking is only required for corporate events, birthday parties and large groups." },
  { q: "Is there a track for kids?", a: "Yes. Alongside the larger main circuit for adults, we have a dedicated smaller junior track so younger drivers can race safely at their own pace." },
  { q: "How do I donate?", a: "Donations are made on track. We are cashless — only credit and debit cards are accepted. There is no online payment required — and every donation helps fund the EduKarting Bahamas youth initiative." },
  { q: "What should I wear?", a: "Closed-toe shoes and comfortable clothing. Helmets and a full safety briefing are provided for every driver." },
];

export const CREDENTIALS = [
  { icon: "shield", t: "Only FIA-Approved Motorsports Club", d: "Karting Bahamas is the only official FIA-approved motorsports club in The Bahamas — connecting us to a network of 245 FIA ASN member clubs worldwide." },
  { icon: "badge", t: "Official FIA Licenses", d: "We are the only club in The Bahamas able to issue both international and national FIA racing licenses." },
  { icon: "heart", t: "Home Of EduKarting (NPO)", d: "The new home of EduKarting Bahamas, a registered non-profit — all proceeds fund its youth development programme." },
];

export const PRESS = [
  {
    img: "/press/rbdf.jpg",
    source: "Royal Bahamas Defence Force",
    date: "2024",
    title: "RBDF partners with Bahamas Motor Sports Association to explore \u201cEduKarting Bahamas\u201d program",
    href: "https://rbdf.gov.bs/rbdf-partners-with-bahamas-motor-sports-association-to-explore-edukarting-bahamas-program/",
  },
  {
    img: "/press/tribune.jpg",
    source: "The Tribune",
    date: "Mar 2023",
    title: "Karting taking 242 to the world",
    href: "https://www.tribune242.com/news/2023/mar/21/karting-taking-242-world/",
  },
  {
    img: "/press/fia.jpg",
    source: "FIA",
    date: "Feature",
    title: "EduKarting give youngsters chance to shine off and on track",
    href: "https://api.fia.com/news/edukarting-give-youngsters-chance-shine-and-track",
  },
  {
    img: "/press/fia-awards.jpg",
    source: "FIA",
    date: "President's Awards",
    title: "EduKarting Bahamas named a finalist for the FIA President's Awards",
    href: "https://api.fia.com/news/fia-announces-finalists-new-presidents-awards1",
  },
  {
    img: "/press/ournews.jpg",
    source: "Our News",
    date: "2024",
    title: "EduKarting introduced to young Bahamians",
    href: "https://ournews.bs/edukarting-introduced-to-young-bahamians/",
  },
  {
    img: "/press/tribune2015.jpg",
    source: "The Tribune",
    date: "Aug 2015",
    title: "EduKarting Bahamas: Teaching life skills through 'stealth education'",
    href: "https://www.tribune242.com/news/2015/aug/18/edukarting-bahamas-teaching-life-skills-through-st/",
  },
];

export const LENOX = {
  name: "Lenox Lockhart",
  flag: "The only Bahamian flying the flag in international karting",
  lead: "The first Bahamian ever to win a national motorsports championship — and the only Bahamian representing The Bahamas in karting on the international stage.",
  bio: [
    "From the tracks of The Bahamas to the grids of Europe, Lenox Lockhart is rewriting what's possible for Bahamian motorsport. In 2025 he was crowned US Champion in his category, and in 2026 he makes his international debut with Italy's renowned Parolin Racing Team.",
    "A relentless competitor, Lenox has claimed a USPKS national championship, multiple vice-champion titles at the SKUSA Pro Tour and IAME Grand Nationals, and even took pole position in the ACI Italian Championship — beating a field of 68 drivers. His goal? The pinnacle of the sport: Formula 1.",
  ],
  achievements: [
    { v: "2025", l: "US Champion — his category" },
    { v: "1st", l: "USPKS National Champion" },
    { v: "P1", l: "Pole — ACI Italian C'ship (of 68)" },
    { v: "2026", l: "Parolin Racing debut, Italy" },
  ],
  website: "https://www.lenoxlockhart.com/",
  heroImg: "/lenox/hero.jpg",
  actionImg: "/lenox/quote.jpg",
};

export const PARTNERS = {
  intro: "Our FIA accreditation connects Karting Bahamas to a global family of grassroots motorsport builders. We proudly collaborate with continental partners growing the sport from the ground up.",
  items: [
    {
      name: "Karting Africa",
      logo: "/partners/karting-africa-logo.jpg",
      image: "/partners/karting-africa.jpg",
      desc: "A Worr Motorsport initiative promoting grassroots development across the African continent through fair, competitive racing — laying the groundwork for affordable advancement toward single-seaters.",
      href: "https://kartingafrica.com/",
    },
    {
      name: "Worr Motorsport",
      logo: "/partners/worr-logo.jpg",
      image: null,
      desc: "Africa's premier karting development team, based in South Africa. Worr combines elite race engineering, driver coaching, professional mechanics and world-class equipment to prepare the next generation of African talent for the world stage.",
      href: "https://worrmotorsport.com/",
    },
  ],
};

export const F1_AWARENESS = {
  articleTitle: "Young kart racers hoping to be the next Lewis Hamilton",
  lead: "The EduKarting story has reached the very top of world motorsport. Formula 1 champions and the FIA President himself have shown their support for what The Bahamas is building — each holding The Tribune's feature on our young racers.",
  people: [
    { img: "/bmsa/alonso.jpg", name: "Fernando Alonso", role: "2× F1 World Champion" },
    { img: "/bmsa/verstappen.jpg", name: "Max Verstappen", role: "4× F1 World Champion" },
    { img: "/bmsa/russell.jpg", name: "George Russell", role: "F1 Grand Prix Winner" },
    { img: "/bmsa/bensulayem.jpg", name: "Mohammed Ben Sulayem", role: "FIA President, with David McLaughlin" },
    { img: "/bmsa/paolo.jpg", name: "Paolo Garzaroli", role: "President, Graycliff Cigar Co. — EduKarting supporter" },
  ],
};

export const SPEEDWEEK = {
  image: "/speedweek/speedweek.jpg",
  davidImg: "/speedweek/david.jpg",
  body: [
    "The original Nassau Speed Weeks (1954–1966) were legendary — drawing icons like Stirling Moss, Bruce McLaren, Carroll Shelby and Dan Gurney to race on New Providence Island. It was one of the great events of world motorsport.",
    "Decades later, David McLaughlin brought it roaring back. As head organiser, he led the Bahamas Speed Week Revivals (2011–2013) — vintage racing, concours, hillclimbs and sprints that reignited the nation's passion for motorsport.",
    "Out of that momentum, EduKarting Bahamas was born — turning a celebration of heritage into a lasting programme that develops young Bahamian talent to this day.",
  ],
  david: "David McLaughlin is the current President of EduKarting Bahamas and the Bahamas Motor Sports Federation, and was the head organiser of the Bahamas Speed Week Revivals.",
  sources: [
    { label: "Speed Week history — Karting Bahamas", href: "https://www.kartingbahamas.com/speedweeks" },
    { label: "Bahamas Speed Week Revival — Supercars.net", href: "https://www.supercars.net/blog/bahamas-speed-week-revival/" },
    { label: "EduKarting — About David McLaughlin", href: "https://www.edukarting-bahamas.com/about" },
  ],
};
